import { createFileRoute, Link } from "@tanstack/react-router"
import { RelistPolicyTable } from "../components/settings/relist-policy-table"
import { RelistSettingsOverview } from "../components/settings/relist-settings-overview"
import { RelistSettingsFeedback } from "../components/settings/relist-settings-feedback"
import { useAuth } from "../hooks/use-auth"
import { useRelistSettings } from "../hooks/use-relist-settings"

export function ListingAutomationPage() {
  const settings = useRelistSettings()
  const { inbox } = settings
  const auth = useAuth()
  const canEdit = auth.user?.role === "admin"
  const rows = inbox.data?.marketplaces ?? []
  return (
    <section aria-labelledby="listing-automation-title" className="space-y-4">
      <RelistSettingsOverview settings={settings} canEdit={canEdit} />

      <Link
        className="mb-4 inline-flex text-sm underline underline-offset-4"
        to="/runs"
        search={{ status: "all", origin: "automatic" }}
      >
        View automatic relist runs
      </Link>

      {inbox.isError && (
        <p role="alert" className="rounded-lg bg-destructive/5 p-4 text-sm text-destructive">
          {inbox.data
            ? "This view could not be refreshed. Settings may be stale."
            : "This view could not be loaded."}{" "}
          Refresh before making another change.
        </p>
      )}

      {inbox.isLoading && (
        <div
          aria-label="Loading marketplaces"
          role="status"
          className="divide-y divide-border rounded-xl border border-border bg-card"
        >
          {[0, 1, 2, 3].map((index) => (
            <div key={index} className="h-24 px-5 py-5">
              <div className="h-4 w-40 rounded bg-muted motion-safe:animate-pulse" />

              <div className="mt-3 h-3 w-56 max-w-full rounded bg-muted motion-safe:animate-pulse" />
            </div>
          ))}
        </div>
      )}

      {inbox.data && rows.length === 0 && (
        <p className="rounded-xl border border-dashed border-border bg-card px-5 py-12 text-center text-sm text-muted-foreground">
          No marketplaces are configured yet. Add one in Marketplaces to control auto relist here.
        </p>
      )}

      {rows.length > 0 && <RelistPolicyTable settings={settings} canEdit={canEdit} />}

      <RelistSettingsFeedback settings={settings} />
    </section>
  )
}

export const Route = createFileRoute("/settings/listing-automation")({
  component: ListingAutomationPage,
})
